export const defaultPaddingX = { xs: 2, sm: 5, md: 10, lg: 14 };
